export {
  mitrexValueVsPrice,
  mpaWallValueVsPrice,
  mpaRailingValueVsPrice,
  dpaWallValueVsPrice,
  dpaRailingValueVsPrice
}

const mitrexValueVsPrice = {
  id: 'value_vs_price',
  name: 'Financial Flow',
  type: 'pricing',
  subsections: []
}

const mpaRailingValueVsPrice = [
  { 
    id: 'title',
    form: {
      component: 'VTextField',
      bind: {
        placeholder: 'Value vs.price'
      }
    },
    display: {
      component: 'h2'
    },
    value: 'SolaRail (MPA)'
  },
  { 
    id: 'content',
    pricing_type: 'mpa',
    wall_railing: 'railing',
    display: {
      component: 'ValueSolarRailing',
      bind: {
        pricingType: 'mpa'
      }
    },
    value: ''
  },
  { 
    id: 'desc',
    form: {
      component: 'VTextArea',
      bind: {
        placeholder: 'Value vs. price section description',
        rows: 3
      }
    },
    display: {
      component: 'p'
    },
    value: ''
  }
]

const mpaWallValueVsPrice = [
  { 
    id: 'title',
    form: {
      component: 'VTextField',
      bind: {
        placeholder: 'Value vs.price'
      }
    },
    display: {
      component: 'h2'
    },
    value: 'Solar Wall (MPA)'
  },
  { 
    id: 'content',
    pricing_type: 'mpa',
    wall_railing: 'wall',
    display: {
      component: 'ValueSolarWall',
      bind: {
        pricingType: 'mpa'
      }
    },
    value: ''
  },
  { 
    id: 'desc',
    form: {
      component: 'VTextArea',
      bind: {
        placeholder: 'Value vs. price section description',
        rows: 3
      }
    },
    display: {
      component: 'p'
    },
    value: ''
  }
]

const dpaRailingValueVsPrice = [
  { 
    id: 'title',
    form: {
      component: 'VTextField',
      bind: {
        placeholder: 'Value vs.price'
      }
    },
    display: {
      component: 'h2'
    },
    value: 'SolaRail (DPA)'
  },
  { 
    id: 'content',
    pricing_type: 'dpa',
    wall_railing: 'railing',
    display: {
      component: 'ValueSolarRailing',
      bind: {
        pricingType: 'dpa'
      }
    },
    value: ''
  },
  { 
    id: 'desc',
    form: {
      component: 'VTextArea',
      bind: {
        placeholder: 'Value vs. price section description',
        rows: 3
      }
    },
    display: {
      component: 'p'
    },
    value: ''
  }
]

const dpaWallValueVsPrice = [
  { 
    id: 'title',
    form: {
      component: 'VTextField',
      bind: {
        placeholder: 'Value vs.price'
      }
    },
    display: {
      component: 'h2'
    },
    value: 'Solar Wall (DPA)'
  },
  { 
    id: 'content',
    pricing_type: 'dpa',
    wall_railing: 'wall',
    display: {
      component: 'ValueSolarWall',
      bind: {
        pricingType: 'dpa'
      }
    },
    value: ''
  },
  { 
    id: 'desc',
    form: {
      component: 'VTextArea',
      bind: {
        placeholder: 'Value vs. price section description',
        rows: 3
      }
    },
    display: {
      component: 'p'
    },
    value: ''
  }
]